import { ReactNode, useState } from 'react';
import {
  Dialog,
  DialogContentHeadless,
  DialogTrigger
} from 'v5/design-system/Dialog';
import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { BookingCostDialogContent } from './booking/BookingCostDialogContent';
import { ExpenseCostDialogContent } from './expense/ExpenseCostDialogContent';
import { EntitySpec } from './types';

export interface BookingCostDialogProps {
  entitySpec: EntitySpec;
  className?: string;
  children: ReactNode;
}

export const BookingCostDialog = ({
  entitySpec,
  className,
  children
}: BookingCostDialogProps) => {
  const [open, setOpen] = useState(false);

  const renderDialogContent = () => {
    switch (entitySpec.type) {
      case 'expense':
        return (
          <ExpenseCostDialogContent
            entitySpec={entitySpec}
            open={open}
            onOpenChange={setOpen}
          />
        );
      case 'booking':
        return (
          <BookingCostDialogContent
            entitySpec={entitySpec}
            open={open}
            onOpenChange={setOpen}
          />
        );
    }
  };
  return (
    <UnsavedChangesProtection open={open} onOpenChange={setOpen}>
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogTrigger asChild className={className}>
            {children}
          </DialogTrigger>
          <DialogContentHeadless>{renderDialogContent()}</DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
};
